/* ==========================================================================
   our-story.js — Controles de vídeo inline + modal fullscreen
   Usa data-os-* para evitar conflito com social-proof.js
   ========================================================================== */

(function () {
  'use strict';

  /* -------------------------------------------------------------------------
     CONTROLES INLINE (play/pause + mute/unmute)
  ------------------------------------------------------------------------- */

  function initOsVideo() {
    var slide = document.querySelector('.os-video-slide');
    if (!slide || slide.dataset.osInit) return;
    slide.dataset.osInit = '1';

    var video   = slide.querySelector('.os-slide-video');
    var playBtn = slide.querySelector('[data-os-play]');
    var muteBtn = slide.querySelector('[data-os-mute]');

    if (!video) return;

    function syncPlay() {
      if (!playBtn) return;
      var playing = !video.paused;
      playBtn.classList.toggle('is-playing', playing);
      playBtn.setAttribute('aria-label', playing ? 'Pausar' : 'Reproduzir');
    }

    function syncMute() {
      if (!muteBtn) return;
      muteBtn.classList.toggle('is-muted', video.muted);
      muteBtn.setAttribute('aria-label', video.muted ? 'Desmutar' : 'Mutar');
    }

    video.addEventListener('play',  syncPlay);
    video.addEventListener('pause', syncPlay);

    video.play().then(syncPlay).catch(syncPlay);

    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.paused ? video.play().catch(function () {}) : video.pause();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        syncMute();
      });
    }
  }

  /* -------------------------------------------------------------------------
     MODAL FULLSCREEN
  ------------------------------------------------------------------------- */

  function initOsModal() {
    var modal    = document.getElementById('os-video-modal');
    var videoEl  = modal && modal.querySelector('.os-modal-video');
    var closeBtn = modal && modal.querySelector('.os-modal-close');

    if (!modal || !videoEl) return;

    var slideVideo = null;

    function openModal(src, sv) {
      slideVideo = sv || null;
      if (slideVideo) slideVideo.pause();
      videoEl.src = src;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      videoEl.play().catch(function () {});
    }

    function closeModal() {
      videoEl.pause();
      videoEl.src = '';
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (slideVideo) {
        slideVideo.play().catch(function () {});
        slideVideo = null;
      }
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    document.addEventListener('click', function (e) {
      var fsBtn = e.target.closest('[data-os-fullscreen]');
      if (!fsBtn) return;
      e.stopPropagation();
      var sl  = fsBtn.closest('[data-os-video-src]');
      var src = sl && sl.dataset.osVideoSrc;
      var sv  = sl && sl.querySelector('.os-slide-video');
      if (src) openModal(src, sv);
    });
  }

  /* -------------------------------------------------------------------------
     INIT
  ------------------------------------------------------------------------- */

  function init() {
    initOsVideo();
    initOsModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
